<script lang="ts">
  // The bottom half of an activity's description of itself: description, gauges, metrics, fitness
  // context and signature. Paired with ActivityCardTitleDetails, which carries the name, tags and
  // terrain profile above it; the long card and the details dialog both stack the two.
  import { cn } from '@/lib/utils';
  import ActivityDescription from './ActivityDescription.svelte';
  import ActivityFitnessStrip from './ActivityFitnessStrip.svelte';
  import ActivityGaugeStats from './ActivityGaugeStats.svelte';
  import ActivityMetrics from './ActivityMetrics.svelte';
  import ActivitySignatureStrip from './ActivitySignatureStrip.svelte';
  import {
    cardLayoutForWidth,
    hasTerrainToShow,
    type CardLayout,
    type DashboardActivity,
  } from './activityCardUtils';

  export let exercise: DashboardActivity;
  /**
   * Which tier to lay out for. The long card decides this from the width these rows actually get --
   * which is not always the card's, since the `md` card runs them the full width underneath the
   * image; anywhere else, leaving it unset measures this column itself.
   */
  export let layout: CardLayout | null = null;

  let ownSize: ResizeObserverSize[] | null = null;
  let ownWidth: number = 0;
  $: if (ownSize && ownSize[0]) ownWidth = ownSize[0].inlineSize;
  $: tier = layout ?? cardLayoutForWidth(ownWidth);

  $: description = exercise?.description?.trim() ?? '';
  /** With no terrain there is no profile to read distance off, so the metrics row shows it instead. */
  $: hasTerrain = hasTerrainToShow(exercise);
</script>

<div bind:borderBoxSize={ownSize} class={cn('min-w-0 flex flex-col', tier === 'xs' ? 'gap-3' : 'gap-2.5')}>
  {#if description}
    <ActivityDescription text={description} lines={tier === 'xs' ? 3 : 2} />
  {/if}

  <ActivityGaugeStats {exercise} layout={tier} />

  <ActivityMetrics {exercise} layout={tier} showDistance={!hasTerrain} />

  <ActivityFitnessStrip summary={exercise?.fitness_summary} layout={tier} />

  <ActivitySignatureStrip {exercise} />
</div>
